// prettier-ignore
/* istanbul ignore next */
export class Logger {
  constructor(loggerName = 'BaOauthFetchLogger') {
    this.loggerName = loggerName;
    this.level = 'ERROR';
  }
  setLevel(level) {
    this.level = level !== null && level !== void 0 ? level : 'ERROR';
  }
  info(message, ...data) {
    if (['WARN', 'ERROR'].includes(this.level)) {
      return;
    }
    console.info(`${this.loggerName}: ${message}`, ...data);
  }
  warn(message, ...data) {
    if (['ERROR'].includes(this.level)) {
      return;
    }
    console.warn(`${this.loggerName}: ${message}`, ...data);
  }
  error(message, ...data) {
    console.error(`${this.loggerName}: ${message}`, ...data);
  }
}
export const oauthLogger = new Logger();
//# sourceMappingURL=logging.utils.js.map
